<template>
  <div class="orderlist">
    <Nav :title="title" :hasOrder="hasOrder" :back="back"></Nav>

    <div class="content" :class="{ isIosx: isiOSX }" id="content">
      <div class="loading" v-if="isLoad">
        <img src="./../../assets/takingCar/loading.gif" alt="" />
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="!isLoad">
        <van-list
          class="allList"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="已无更多行程～"
          @load="onLoad"
          :offset="10"
        >
          <p class="orderStatus" v-if="unfinishedList.length > 0">未完成订单</p>
          <div
            class="list"
            v-for="(item, index) in unfinishedList"
            :key="index"
            @click="goToSeeDetail(item, index)"
          >
            <p class="title" :class="{ activeTitle: item.status == 30 }">
              <span class="left"
                >{{
                  item.platform != null
                    ? item.platform.platform_name.substring(0, 2)
                    : ""
                }}{{ item.car_type_name
                }}<span
                  class="t3tip1"
                  v-if="item.platform && item.platform.short_name == 'T3'"
                  >不支持开票</span
                >
                <span class="airport" v-if="item.platform && (item.type == 3 || item.type == 4)">
                接送机
              </span>
                </span
              >
              
              <span class="right">
                <span v-show="item.status == 30">出行中</span>
                <span
                  v-show="
                    item.status == 10 ||
                    item.status == 15 ||
                    item.status == 20 ||
                    item.status == 25
                  "
                  >待出行</span
                >
                <span v-show="item.status == 40">待支付</span>
              </span>
            </p>
            <p class="orderDate">
              <img src="./../../assets/takingCar/time.png" alt />
              {{ item.created_at }}
            </p>
            <p class="orderCfd">
              <img src="./../../assets/takingCar/qsd.png" alt />
              <span>{{ item.start_position }}</span>
            </p>
            <div class="middash">
              <img src="./../../assets/takingCar/middash.png" alt="" />
            </div>
            <p class="orderMdd">
              <img src="./../../assets/takingCar/zd.png" alt />
              <span>{{ item.end_address }}</span>
            </p>
             <span
              class="tip"
              v-if="item.is_refund != 20 && item.complaint_status == 10"
              >投诉已提交</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && 
                ((item.complaint_status == 20) ||
                item.complaint_status == 30 ||
                item.complaint_status == 40)
              "
              >投诉处理中</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && item.complaint_status == 50"
              >投诉已处理</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && item.complaint_status == 60"
              >投诉无效</span
            >
          </div>

          <p class="orderStatus" v-if="finishedList.length > 0">已完成订单</p>
          <div
            class="list"
            v-for="(item, index) in finishedList"
            :key="index + 'a'"
            @click="goToSeeDetail(item, index)"
            :class="item.platform == null ? 'noNameList' : ''"
          >
            <p
              class="title"
              :class="item.platform == null ? 'noneCarNameLeft' : ''"
            >
              <span class="left"
                >{{
                  item.platform != null
                    ? item.platform.platform_name.substring(0, 2)
                    : ""
                }}{{ item.car_type_name
                }}<span
                  class="t3tip"
                  v-if="item.platform && item.platform.short_name == 'T3'"
                  >不支持开票</span
                >
                <span class="airport" v-if="item.platform && (item.type == 3 || item.type == 4)">
                接送机
              </span>
                </span
              >
              <span class="right">
                <span v-if="item.status == 50"
                  >已完成 {{ item.platform_price | moneyFormat }}元</span
                >
                <span v-else-if="item.status == 60"
                  >已关闭{{
                    item.cancel_money > 0 ? item.cancel_money + "元" : ""
                  }}</span
                >
                <span v-else>已关闭</span>
              </span>
            </p>
            <div :class="item.platform == null ? 'noneCarNameRight' : ''">
              <p class="orderDate">
                <img src="./../../assets/takingCar/time.png" alt />
                {{ item.created_at }}
              </p>
              <p class="orderCfd">
                <img src="./../../assets/takingCar/qsd.png" alt />
                <span>{{ item.start_position }}</span>
              </p>
              <div class="middash">
                <img src="./../../assets/takingCar/middash.png" alt="" />
              </div>
              <p class="orderMdd">
                <img src="./../../assets/takingCar/zd.png" alt />
                <span>{{ item.end_address }}</span>
              </p>
            </div>

            <div
              class="integral"
              v-if="item.status == 50 && item.return_credits_status == 1 && item.complaint_status == -1 && item.is_refund == 0"
              @click.stop="toIntegral(item)"
            >
              领积分
              <img src="./../../assets/takingCar/getIntegral.png" alt="" />
            </div>
            <div
              class="integral integralNone"
              v-if="item.status == 50 && item.return_credits_status == 2"
              @click.stop
            >
              积分已领取
            </div>
            <span
              class="tip"
              v-if="item.is_refund == 20"
              >退款成功</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && item.status == 50 && item.complaint_status == 10"
              >投诉已提交</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && 
                ((item.status == 50 && item.complaint_status == 20) ||
                item.complaint_status == 30 ||
                item.complaint_status == 40)
              "
              >投诉处理中</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && item.status == 50 && item.complaint_status == 50"
              >投诉已处理</span
            >
            <span
              class="tip"
              v-if="item.is_refund != 20 && item.status == 50 && item.complaint_status == 60"
              >投诉无效</span
            >
          </div>
        </van-list>
      </van-pull-refresh>
      <van-row
        class="empty"
        v-if="unfinishedList.length < 1 && finishedList.length < 1 && !isLoad"
      >
        <van-col class="emptyMsg" span="24">
          <p class="tip1">当前暂无行程～</p>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "我的订单",
      isiOSX: false,
      //   下拉刷新
      isLoading: false, //加载中
      loading: false,
      page: 1,
      finished: false, //endtip
      hasOrder: true,
      list: [
        // {
        //   carCj: "易道打车",
        //   status: 1,
        //   cxsj: "2020-06-23  17:15",
        //   cfd: "泛海国际中心东门",
        //   mdd: "杭州东站（东1门）"
        // },
      ],
      unfinishedList: [],
      finishedList: [],
      back: 1,
      isLoad: true,
      istoIntegral: true,
    };
  },
  components: { Nav },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
    sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
    this.getOrderList();
  },
  filters: {
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  watch: {
    $route: "getPath",
  },
  methods: {
    onLoad() {
      // console.log("加载更多");
      this.page++;
      this.getOrderList(2);
    },
    // 下拉刷新
    onRefresh() {
      // console.log("下拉刷新");
      this.page = 1;
      this.finished = false;
      this.getOrderList(1);
    },
    // 查看详情
    goToSeeDetail(item, index) {
      // console.log(item);
      let param = JSON.stringify({
        expect_start_longitude: item.expect_start_longitude,
        expect_start_latitude: item.expect_start_latitude,
        expect_end_longitude: item.expect_end_longitude,
        expect_end_latitude: item.expect_end_latitude,
        status: item.status,
        taxis_order_sn: item.taxis_order_sn,
      });
      // console.log(param);
      this.params(param, param, "goToSeeDetail");
    },
    // 领积分
    toIntegral(item) {
      if (this.istoIntegral) {
        this.istoIntegral = false;
        console.log(item);
        this.$api
          .post("/taxis/member/order/get/credits", { taxis_order_sn: item.taxis_order_sn })
          .then((res) => {
            // console.log(res);
            this.istoIntegral = true;
            this.$toast("领取成功");
            item.return_credits_status = 2;
            this.unfinishedList = [...this.unfinishedList];
          })
          .catch((res) => {
            this.istoIntegral = true;
            this.$toast("领取失败");
          });
      }

      // let param = JSON.stringify({
      //   expect_start_longitude: item.expect_start_longitude,
      //   expect_start_latitude: item.expect_start_latitude,
      //   expect_end_longitude: item.expect_end_longitude,
      //   expect_end_latitude: item.expect_end_latitude,
      //   status: item.status,
      //   taxis_order_sn: item.taxis_order_sn,
      // });
      // // console.log(param);
      // this.params(param, param, "toIntegral");
    },
    // 获取订单列表
    getOrderList(type) {
      if (type == 1) {
        // 刷新
        this.$api
          .post("/taxis/member/order/mine/list", { page: 1 })
          .then((res) => {
            // console.log(res);
            if (res.list.length == 0) {
              this.hasOrder = false;
            } else {
              this.hasOrder = true;
            }
            this.unfinishedList = [];
            this.finishedList = [];
            this.isLoading = false;
            res.list.forEach((item) => {
              if (
                item.status == 10 ||
                item.status == 15 ||
                item.status == 20 ||
                item.status == 25 ||
                item.status == 30 ||
                item.status == 40
              ) {
                this.unfinishedList.push(item);
              } else {
                this.finishedList.push(item);
              }
            });
          });
      } else if (type == 2) {
        // 加载更多
        this.$api
          .post("/taxis/member/order/mine/list", { page: this.page })
          .then((res) => {
            // console.log(res);
            this.loading = false;
            this.total = res.total;
            if (res.list == null || res.list.length === 0) {
              // 加载结束
              this.finished = true;
              return;
            }

            // 将新数据与老数据进行合并
            res.list.forEach((item) => {
              if (
                item.status == 10 ||
                item.status == 15 ||
                item.status == 20 ||
                item.status == 25 ||
                item.status == 30 ||
                item.status == 40
              ) {
                this.unfinishedList.push(item);
              } else {
                this.finishedList.push(item);
              }
            });
            // console.log(this.unfinishedList.length + this.finishedList.length);
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (
              this.unfinishedList.length + this.finishedList.length >=
              this.total
            ) {
              this.finished = true;
            }
          });
      } else {
        // 加载数据
        this.$api
          .post("/taxis/member/order/mine/list", { page: this.page })
          .then((res) => {
            this.isLoad = false;
            // console.log(res);
            if (res.list.length == 0) {
              this.hasOrder = false;
            }
            this.isLoading = false;
            res.list.forEach((item) => {
              if (
                item.status == 10 ||
                item.status == 15 ||
                item.status == 20 ||
                item.status == 25 ||
                item.status == 30 ||
                item.status == 40
              ) {
                this.unfinishedList.push(item);
              } else {
                this.finishedList.push(item);
              }
            });
          });
      }
      // console.log(this.finishedList);
    },
  },
  mounted() {
    let winHeight = document.documentElement.clientHeight; //浏览器视口大小
    document.getElementById("content").style.height = winHeight - 70 + "px"; //调整框高度
  },
};
</script>

<style lang="less">
.orderlist {
  min-height: 100%;
  background: #f5f6f7;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .content {
    padding-top: 70px;
    margin: 0 15px;
    //  border: 1px solid red;
    overflow: scroll;
    .van-list {
      .orderStatus {
        color: #999999;
        font-size: 13px;
        height: 18px;
        line-height: 18px;
        margin: 15px 0;
      }
      .list {
        background-color: #ffffff;
        border-radius: 5px;
        font-size: 13px;
        line-height: 18px;
        margin-bottom: 10px;
        position: relative;
        // min-height: 105px;
        // padding-bottom: 15px;

        .title {
          height: 45px;
          background-color: #ffffff;
          border-radius: 5px;
          color: #333333;
          overflow: hidden;
          font-size: 15px;
          line-height: 45px;
          padding-top: 3px;
          .left {
            float: left;
            margin-left: 15px;
            font-weight: bolder;
            display: flex;
            align-items: center;
            .t3tip {
              background-color: #fff7e4;
              color: #b78100;
              font-weight: 400;
              font-size: 12px;
              margin: 0px 0 0 5px;
              padding: 2px 5px;
              border-radius: 4px;
              height: 17px;
              line-height: 17px;
            }
            .t3tip1 {
              background-color: #d4ffdf;
              color: #138230;
              font-weight: 400;
              font-size: 12px;
              margin: 0px 0 0 5px;
              padding: 2px 5px;
              border-radius: 4px;
              height: 17px;
              line-height: 17px;
            }
            .airport{
              display: inline-block;
              width: 60px;
              height: 24px;
              line-height: 24px;
              text-align: center;
              background: url('./../../assets/takingCar/airport.png') no-repeat 0 0;
              background-size: 100%;
              margin-left: 10px;
              font-size: 12px;
              font-weight: 400;
              color: #FF5700;
            }
          }
          .right {
            float: right;
            margin-right: 15px;
            color: #999999;
          }
        }
        .activeTitle {
          background-color: #2ab74f;
          color: #ffffff;
          margin-bottom: 5px;
          padding-top: 0;
          .right {
            color: #ffffff;
          }
        }
        p {
          img {
            width: 9.78px;
            height: 9.78px;
            margin: 0 8px 0 15px;
          }
        }

        .orderDate {
          color: #999999;
          margin: 0px 0px 8px 0px;
        }
        .orderCfd {
          color: #333333;
          display: flex;
          align-items: center;
          span {
            flex: 1;
          }
        }
        .middash {
          width: 1px;
          height: 11px;
          position: relative;
          top: -3px;
          left: 19px;
          img {
            width: 1px;
            height: 11px;
          }
        }
        .orderMdd {
          color: #333333;
          margin: -1px 80px 0 0px;
          padding-bottom: 15px;
          display: flex;
          align-items: center;
          span {
            flex: 1;
          }
        }
        // .noneCarName {
        //   // border: 1px solid red;
        //   position: absolute;
        //   top: 17px;
        // }

        .integral {
          // width: 65px;
          line-height: 23px;
          border-radius: 10.5px;
          background-color:#FF5700;
          color: #ffffff;
          padding-left: 10px;
          position: absolute;
          bottom: 14px;
          right: 15px;
          height: 23px;
          img {
            width: 23px;
            line-height: 10px;
            transform: translateX(-4px);
          }
        }
        .integralNone {
          background-color: #ffffff;
          color: #FF9A66;
          text-align: right;
        }
        .tip {
          color: #ffb600;
          position: absolute;
          top: 38px;
          right: 15px;
        }
      }
      .van-list__finished-text {
        color: #999999;
        font-size: 15px;
        line-height: 21px;
        text-align: center;
        margin-top: 15px;
        margin-bottom: 53px;
      }
    }
    .noNameList {
      display: flex;
      justify-content: space-between;
      .noneCarNameLeft {
        // border: 1px solid red;
        order: 2;
        min-width: 77px;
      }
      .noneCarNameRight {
        // border: 1px solid blue;
        order: 1;
        padding-top: 17px;
        .orderMdd {
          margin: -1px 0 0 0;
        }
      }
    }

    .empty {
      text-align: center;
      color: #999999;
      font-size: 17px;
      line-height: 24px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
    }
  }
  .isIosx {
    padding-top: 90px;
  }
}
</style>
